export default "__VITE_ASSET__wmsQ$3re__"